export const decemberAbbreviatedLowercase = "TO22te";
export default {decemberAbbreviatedLowercase};